import type { Environment } from '@change-corgi/config/environments';

import __perimeterx from '../config/perimeterx.json';

export type PerimeterXConfig = Readonly<{ appId: string; jsSrc: string }>;

const perimeterXConfigs = __perimeterx as Readonly<Record<Environment, PerimeterXConfig>>;

export const getPerimeterXConfig = (env: Environment): PerimeterXConfig => perimeterXConfigs[env];
